module.exports = __webpack_public_path__ + "media/images/fig_salary-fd9db8db6b27e373b3cd3c57e0594e44.png";